import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { makeStyles } from "tss-react/mui";
import { keyframes } from "tss-react";

const useStyles = makeStyles()((theme) => ({
  loader: {
    width: "100%",
    height: "100%",
    borderRightWidth: theme.spacing(0.5),
    borderRightStyle: "solid",
    borderRightColor: theme.palette.primary.main,
    borderRadius: "100%",
    animation: `${keyframes`
        0% { transform: rotate(360deg) }
        100% { transform: rotate(0deg) }
        `} 1.5s linear infinite`,

    "&:before, &:after": {
      content: '""',
      width: "80%",
      height: "80%",
      display: "block",
      position: "absolute",
      top: "10%",
      left: "10%",
      borderLeftWidth: "3px",
      borderLeftStyle: "solid",
      borderLeftColor: theme.palette.primary.main,
      borderRadius: "100%",
      animation: `${keyframes`
          0% { transform: rotate(0deg) }
          100% { transform: rotate(360deg) }
              `} 1s linear infinite`,
    },
    "&:after": {
      width: "50%",
      height: "50%",
      top: "25%",
      left: "25%",
      border: 0,
      borderRightWidth: theme.spacing(0.25),
      borderRightStyle: "solid",
      borderRightColor: theme.palette.primary.main,
      animation: "none",
    },
  },
}));

const CustomLoader: React.FC<{ loadingMessage?: string }> = ({ loadingMessage }) => {
  const { classes } = useStyles();

  return (
    <React.Fragment>
      <Stack sx={{ height: "100%", justifyContent: "space-around" }} alignItems="center">
        <Stack spacing={8} alignItems="center">
          <Box width="98px" height="98px">
            <div className={classes.loader} role="progressbar" />
          </Box>
          {loadingMessage != null && <Typography variant="h3">{loadingMessage}...</Typography>}
        </Stack>
      </Stack>
    </React.Fragment>
  );
};

export default CustomLoader;
